function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.44 12.21H0v6.66h4.44v-6.66zM11.22.87H6.78v18h4.44v-18zM18 6.85h-4.44v12.02H18V6.85z",
  fill: "#E8E2C6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.44 15.54H0v3.33h4.44v-3.33zM11.22 9.87H6.78v9h4.44v-9zM18 12.86h-4.44v6.01H18v-6.01z",
  fill: "#FFD15C"
});

function SvgTradeActiveinline(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgTradeActiveinline;